import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	overtime: null,
	error: "",
	loading: false,
};

// ADD_overtime
// export const addOvertime = createAsyncThunk(
// 	"overtime/addOvertime",
// 	async (values) => {
// 		try {
// 			const { data } = await axios({
// 				method: "post",
// 				url: `overtime`,
// 				data: {
// 					...values,
// 				},
// 			});
// 			toast.success("Overtime added successfully!");
// 			return {
// 				data,
// 				message: "success",
// 			};
// 		} catch (error) {
// 			toast.error("Error in adding overtime try again");
// 			console.log(error.message);
// 			return {
// 				message: "error",
// 			};
// 		}
// 	}
// );
export const addOvertime = createAsyncThunk(
    "overtime/addOvertime",
    async (values, { rejectWithValue }) => {
        try {
            const { data } = await axios.post("overtime", values);
            toast.success(data.message || "Overtime added successfully!");
            return {
                data,
                message: data.message || "success",
            };
        } catch (error) {
            const errorMessage = error.response?.data?.message || "Error in adding overtime. Try again.";
            toast.error(errorMessage);
            return rejectWithValue({ message: errorMessage });
        }
    }
);


export const takeToil = createAsyncThunk(
	"overtime/takeToil",
	async (values, { rejectWithValue }) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `overtime/takeToil`,
				data: {
					...values,
				},
			});
			toast.success("Take Toil successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			// Capture the error message from the response, if available
			const errorMessage =
				error.response?.data?.message || "Error occurred, please try again.";
			toast.error(errorMessage);
			console.log(error.message);
			return rejectWithValue({
				message: errorMessage,
			});
		}
	}
);


// DELETE_overtime
export const deleteOverTime = createAsyncThunk(
	"overtime/deleteOverTime",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `overtime/${id}`,
			});

			toast.success("Overtime deleted successfully!");
			return {
				data: resp.data,
				message: "success",
			};
		} catch (error) {
			toast.error(error.response?.data?.message || "Error in deleting overtime try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);


// overtime
export const getAllOvertime = createAsyncThunk(
	"overtime/getAllOvertime",
	async () => {
		try {
			const { data } = await axios.get(`overtime`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const getToilData = createAsyncThunk(
	"overtime/getToilData",
	async () => {
		try {
			const { data } = await axios.get(`overtime/get/ToilData`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const getSingleOvertime = createAsyncThunk(
	"overtime/getSingleOvertime",
	async (id) => {
		try {
			const { data } = await axios.get(`overtime/${id}`);

			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const getOvertimeByUser = createAsyncThunk(
	"overtime/getOvertimeByUser",
	async (userId) => {
		try {
			const { data } = await axios.get(`overtime/${userId}/user`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const updateOvertimeStatus = createAsyncThunk(
	"overtime/updateOvertimeStatus",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `overtime/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Overtime updated successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating overtime try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

export const updateOvertime = createAsyncThunk(
	"overtime/updateOvertime",
	async ({ id, values }) => {
		try {
			console.log("Sending to API:", values);
			const { data } = await axios({
				method: "put",

				url: `overtime/overtime/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Overtime updated successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating overtime try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

export const makeOverTimePayment = createAsyncThunk(
	"expense/makeOverTimePayment",
	async ({ id, values }, { rejectWithValue }) => {
		try {
			const { data } = await axios.put(`overtime/payment/${id}`, {
				paymentStatus: values.paymentStatus,
			});

			toast.success("Overtime updated successfully");
			return { data, message: "success" };
		} catch (error) {
			// Extract error message directly from API response
			const errorMessage = error.response?.data?.message || "Error in updating overtime, try again";

			// Show the error message from API
			toast.error(errorMessage);

			// Return the error message to Redux
			return rejectWithValue({ message: errorMessage });
		}
	}
);


const overtimeSlice = createSlice({
	name: "overtime",
	initialState,
	reducers: {
		clearOvertime: (state) => {
			state.overtime = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllOvertime ======

		builder.addCase(getAllOvertime.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllOvertime.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAllOvertime.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 1) ====== builders for getToilData ======

		builder.addCase(getToilData.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getToilData.fulfilled, (state, action) => {
			state.loading = false;
			state.toilData = action.payload;
		});

		builder.addCase(getToilData.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 1) ====== builders for getOvertimeByUser ======

		builder.addCase(getOvertimeByUser.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getOvertimeByUser.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getOvertimeByUser.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addOvertime  ======

		builder.addCase(addOvertime.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addOvertime.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addOvertime.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for takeToil  ======

		builder.addCase(takeToil.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(takeToil.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(takeToil.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});


		builder.addCase(makeOverTimePayment.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(makeOverTimePayment.fulfilled, (state, action) => {
			state.loading = false;
			const list = [...state.list];
			const index = list.findIndex(
				(expense) => expense.id === parseInt(action.payload.data.id)
			);
			list[index] = action.payload.data;
			state.list = list;
		});

		builder.addCase(makeOverTimePayment.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for overtime ======

		builder.addCase(updateOvertimeStatus.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateOvertimeStatus.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateOvertimeStatus.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		builder.addCase(updateOvertime.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateOvertime.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateOvertime.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for getSingleOvertime ======

		builder.addCase(getSingleOvertime.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getSingleOvertime.fulfilled, (state, action) => {
			state.loading = false;

			state.overtimeDetail = action.payload;
		});

		builder.addCase(getSingleOvertime.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteOverTime  ======

		builder.addCase(deleteOverTime.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteOverTime.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteOverTime.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default overtimeSlice.reducer;
export const { clearOvertime } = overtimeSlice.actions;
